import {FC} from 'react'
import { NumericFormat as NumberFormat } from 'react-number-format'

type Props = {
  price?: string
}

const PriceCell: FC<Props> = ({price = '0'}) => (
  <> {price && <div className='align-self-start'>
      <NumberFormat
          className="pt-2"
          value={price} 
          displayType={'text'}
          thousandSeparator={true}
      />
      <span className='pt-2'>{' ₮'} </span>
    </div>
  }</>
)

export {PriceCell}
